<template>
    <div style="height: 100%; display: flex; flex-direction: column;">
        <div style="position: fixed;top: 0;left: 0;width: 100%;z-index: 1000;">
            <van-nav-bar
            title="管理收货地址"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            color="linear-gradient(to right, #ff9900, #ff3333)"
            />
        </div>
        <div class="shipcon">
           <div class="smallgray" style="font-size:0.85rem;margin-bottom:0.5rem;">收货地址管理</div>
           <div>
                <van-panel  style="margin-bottom:1rem;" v-for="(item,index) in addresslist" :key="index">
                    <div slot="header" style="padding:13px 23px 0;">
                        <p style="font-size:0.9rem">{{ item.address }}</p>
                        <div style="border-bottom:1px solid #CCCCCC;font-size:0.85rem;display:flex;justify-content: space-between;color: #999999;padding:0.5rem 0">
                            <div>收货人姓名：{{ item.userName }}</div>
                            <div>{{ item.phone }}</div>
                        </div>
                    </div>
                    <van-row style="padding:10px 23px;height:2rem;display: flex;align-items: center;">
                        <van-col span="12">
                            <van-tag round type="primary" style="display: flex;align-items: center;width: 4.5rem;" v-if="item.status == '1' ? true : false ">
                                <van-icon name="success" style="margin-right:0.5rem;"/><span>默认地址</span>
                            </van-tag>
                            <van-checkbox v-model="item.isdefault" @change="changeDefault(item.isdefault,item)" v-if="item.status == '1' ? false : true " style="font-size:0.875rem">设为默认地址</van-checkbox>
                           <!--  <van-radio-group v-model="item.isdefault" @change="changeDefault(item.isdefault,item.id)" v-if="item.status == '1' ? false : true ">
                                <van-radio name="1" style="font-size:0.875rem">设为默认地址</van-radio>
                            </van-radio-group> -->
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <img src="../assets/imgs/shipaddress_editbtn_icon.png" width="24px;" alt=""  @click="compileAddress('modifier',item)">
                            <img style="margin-left:1rem;" src="../assets/imgs/shipaddress_deletebtn_icon.png" width="24px;" alt="" @click="removeAddress(item.isdefault,item.id)">
                        </van-col>
                    </van-row>
                </van-panel>

                
                
           </div>
        </div>
        <div class="footer" >
            <van-button round type="info"  @click="addAddress('addaddress')"><van-icon name="plus" /><span style="margin-left:0.5rem;">添加收货地址</span></van-button>
        </div>
    </div>
</template>

<script>
import {  NavBar, Row, Col,Icon,Cell, CellGroup,Panel ,Tag,RadioGroup, Radio ,Button ,Toast,Checkbox, CheckboxGroup  } from "vant";

export default {
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Panel.name]: Panel,
        [Tag.name]: Tag,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    data(){
        return{
            addresslist:[],
    }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1)
        },
        addAddress(msg){
            this.$router.push({path : 'compileaddress' , query:{ state:msg }})
        },
        compileAddress(msg,data){
            console.log(data)
            console.log('点击了')
            this.$router.push({path : 'compileaddress' , query:{ state:msg ,data:data}})
        },
        removeAddress(isdefault,id){
            if(isdefault){
                Toast('默认地址无法删除');
            }else{
                let params = {
                    session:this.local.get('session'),
                    userAddressId:id,
                    };
                let _this = this
                console.log(params)
                this.request.delete("/v1/user/address/delete", params)
                .then(res => {
                    console.log(res);
                    if(res.message == '删除成功'){
                        _this.$toast('地址删除成功成功')
                        location.reload();
                    }
                })
                .catch(err => {console.log(err)});
            } 
        },
        changeDefault(msg,item){
            console.log(msg,item);
            if(msg == true){
                let params = {
                session:this.local.get('session'),
                userAddressId:item.id,
                };
                let _this = this
                console.log(params)
                this.request.post("/v1/user/address/default", params)
                .then(res => {
                    console.log(res);
                    if(res.message == '修改成功'){
                        _this.$toast('默认地址设置成功')
                        location.reload();
                    }
                })
                .catch(err => {console.log(err)});
            }
        }
    },
    created(){
        let params = {
            session:this.local.get('session'),
        };
        let _this = this
        this.request.get("/v1/user/address", params)
        .then(res => {
            console.log(res);
            for(let i=0;i<res.data.length;i++){
                if(res.data[i].status == '1'){
                    res.data[i].isdefault = true 
                }else{
                    res.data[i].isdefault = false 
                }
            }
            _this.addresslist = res.data
            console.log(_this.addresslist)
        })
        .catch(err => {console.log(err)});
    },
    activated(){
        let params = {
            session:this.local.get('session'),
        };
        let _this = this
        this.request.get("/v1/user/address", params)
        .then(res => {
            console.log(res);
            for(let i=0;i<res.data.length;i++){
                if(res.data[i].status == '1'){
                    res.data[i].isdefault = true 
                }else{
                    res.data[i].isdefault = false 
                }
            }
            _this.addresslist = res.data
            console.log(_this.addresslist)
        })
        .catch(err => {console.log(err)});
    }
}

</script>

<style lang="less" scoped>
.van-nav-bar {
    background: linear-gradient(to right, #ff9900, #ff3333);
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
}
.van-tag--round{
    border-radius: 1rem;
    height: 1rem;
}
.footer{
    width: 100%;
    height: 5.125rem;
    background: rgba(255,255,255,0.5) ;
    position: fixed;
    bottom: 0;
    left: 0;
    line-height: 5.155rem;
    text-align: center;
    .van-button{
        width: 18rem;
        background: #FF3333;
        font-size: 1.187rem;
    }
    .van-button--info{
        border: 1px solid #FF3333;
    }
    .van-button__text{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .van-icon{
        font-size: 1.187rem;
    }
}
.shipcon{
    padding: 10px 16px 5.5rem;
    background: #FAFAFA;
    flex:1;
    margin-top: 3rem;
}

</style>